const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 13 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-13.9992,-16.4966)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forma-1-copy-15",
    serifId: "Forma 1 copy 15",
    transform: "matrix(1,0,0,1,-718.005,-192.485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.128,209.771C732.046,209.681 732.004,209.568 732.004,209.444C732.004,209.32 732.046,209.207 732.128,209.117C732.294,208.936 732.563,208.936 732.728,209.117L738.005,214.871L743.282,209.117C743.447,208.936 743.716,208.936 743.881,209.117C744.047,209.297 744.047,209.591 743.881,209.771L738.305,215.853C738.14,216.034 737.87,216.034 737.705,215.853L732.128,209.771Z",
    style: {
      fill: "rgb(79,79,79)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.1c6ace4e929fdc41e76d15a8ca9624d6.svg";
export { ForwardRef as ReactComponent };